import env from "@/utils/env"

/**
 * Get the dynamic API origin based on the current domain
 * This allows the app to work with multiple domains (e.g., rnp.io and akrochem.com)
 * by calling the corresponding API domain
 *
 * @returns The API GraphQL endpoint URL
 *
 * @example
 * // When on https://aeros-dev.rnp.io
 * getApiOrigin() // returns "https://aeros-dev-api.rnp.io/graphql"
 *
 * @example
 * // When on https://aeros-dev.akrochem.com
 * getApiOrigin() // returns "https://aeros-dev-api.akrochem.com/graphql"
 */
export const getApiOrigin = (): string => {
  const currentHostname = window.location.hostname

  // Check if we're on an akrochem.com domain
  if (currentHostname.includes("akrochem.com")) {
    // Replace the frontend domain pattern with API domain pattern
    // e.g., aeros-dev.akrochem.com -> aeros-dev-api.akrochem.com
    const apiHostname = currentHostname.replace(/^(aeros-[^.]+)/, "$1-api")
    return `https://${apiHostname}/graphql`
  }

  // For all other domains (including rnp.io, localhost, etc.), use the configured VITE_API_ORIGIN
  return env.VITE_API_ORIGIN
}
